// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"fd940856","977":"aef734ff"}[chunkId] + ".chunk.js";
};